import { Flex, Typography, useScreenSize } from '@banhala/ui-kit';
import { useCallback } from 'react';
import { AblyIcon } from './components/AblyIcon';
import { useAppDownloadModal } from 'shared/src/hooks';
import { ablyUserAgent, airbridge } from '@banhala/utils';
import { useRoute } from '@react-navigation/native';

export const AppDownloadBanner: React.FC = () => {
  const size = useScreenSize();
  const { show: showModal } = useAppDownloadModal();
  const routes = useRoute();

  const onPressBanner = useCallback(() => {
    if (ablyUserAgent.isMobile) {
      const targetParams = Object.keys(routes.params ?? {})
        .filter(key => key !== 'instanceId')
        .reduce(
          (cur, key) => ({
            ...cur,
            [key]: (routes.params as Record<string, string>)[key],
          }),
          {},
        );
      const params = routes.params
        ? (Object.values(targetParams)?.[0] ?? null)
        : null;

      const link = `ably://react/App?screen=${routes.name}${params ? `&extras=${encodeURIComponent(JSON.stringify({ sno: params }))}` : ''}`;

      airbridge.openDeeplink({
        type: 'redirect',
        deeplinks: {
          ios: link,
          android: link,
        },
        fallbacks: {
          ios: 'itunes-appstore',
          android: 'google-play',
        },
      });
      return;
    }
    showModal();
  }, [routes.name, routes.params, showModal]);

  return (
    <Flex
      alignItems={'center'}
      justifyContent={'center'}
      backgroundColor={'white'}
    >
      <Flex.Row
        width={size.width}
        backgroundColor={'bg_pink_primary'}
        padding={{ vertical: 8, horizontal: 10 }}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Flex.Row gap={8} alignItems={'center'} justifyContent={'center'}>
          <AblyIcon />
          <Typography color={'content_always_white'} type={'body4'}>
            앱에서 더 많은 상품을 볼 수 있어요!
          </Typography>
        </Flex.Row>
        <Flex
          backgroundColor={'white'}
          borderRadius={20}
          alignItems={'center'}
          justifyContent={'center'}
          height={28}
          padding={{ horizontal: 8 }}
          onPress={onPressBanner}
        >
          <Typography type={'subtitle6'} color={'content_primary'}>
            앱에서 보기
          </Typography>
        </Flex>
      </Flex.Row>
    </Flex>
  );
};
